/**
 * Leadership Dashboard — Data Engine + Sample Data Generator
 * Adapted from Prozo_Leadership_Dashboard_Mockup.html
 */

import axios from 'axios'
import { apiConstants } from '../../common/constants'

const R = Math.round

// ─── ENGINE ───────────────────────────────────────────────────────────────────
// Processes a tabs object (same shape as the Google Sheets export) into VM.
// tabs = { master: [[]], raw0: [[]], raw1: [[]], raw2: [[]], win: { months: [] } }
export function ENGINE(tabs) {
  const norm = s => (s || '').toString().trim().replace(/\s+/g, ' ')
  const key  = s => norm(s).toLowerCase()
  const num  = v => { const n = parseFloat((v || '').toString().replace(/[^0-9.\-]/g, '')); return isNaN(n) ? 0 : n }

  // Detect monthly data start column from year row
  const yr = tabs.master[1] || []
  let mc = -1
  for (let c = 0; c < yr.length; c++) {
    if (/^20\d{2}$/.test((yr[c] || '').toString().trim())) { mc = c; break }
  }
  if (mc < 0) mc = 8

  const firstYear = parseInt((yr[mc] || '2025'), 10) || 2025
  let _k = 0
  for (let c = mc; c < yr.length && (yr[c] || '').toString().trim() === String(firstYear); c++) _k++
  let startMo = 13 - _k, startYr = firstYear
  while (startMo < 1) { startMo += 12; startYr-- }

  const MSHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  const MON = [], MLABe = [], MCOL = {}
  {
    let y = startYr, mo = startMo
    for (let c = mc; c < yr.length; c++) {
      const yv = (yr[c] || '').toString().trim()
      if (!/^20\d{2}$/.test(yv)) break
      const kk = MSHORT[mo - 1] + String(y).slice(2)
      MON.push(kk); MLABe.push(MSHORT[mo - 1] + ' ' + String(y).slice(2))
      MCOL[y + '-' + mo] = c
      mo++; if (mo > 12) { mo = 1; y++ }
    }
  }

  const win = tabs.win || {}, wm = win.months || []
  const _lc = mc + MON.length - 1
  const _cof = o => (o && MCOL[o.y + '-' + o.m] != null) ? MCOL[o.y + '-' + o.m] : null
  const c0 = _cof(wm[0]) != null ? _cof(wm[0]) : _lc - 2
  const c1 = _cof(wm[1]) != null ? _cof(wm[1]) : _lc - 1
  const c2 = _cof(wm[2]) != null ? _cof(wm[2]) : _lc
  const k0 = MON[c0 - mc], k1 = MON[c1 - mc], k2 = MON[c2 - mc]
  const D0  = (wm[0] && wm[0].days) || 30
  const D1  = (wm[1] && wm[1].days) || 31
  const DIM = (wm[2] && wm[2].days) || 30

  // Detect Priority and Potential DRR columns
  const hdr2 = tabs.master[2] || []
  let pc = -1
  for (let c = 0; c < hdr2.length; c++) {
    if (/priority/i.test((hdr2[c] || '').toString())) { pc = c; break }
  }
  const pdc = pc >= 0 ? pc - 1 : -1

  // Parse accounts
  const accts = []
  for (let i = 3; i < tabs.master.length; i++) {
    const r    = tabs.master[i]
    const name = norm(r[0]); const ct = norm(r[1]).toUpperCase()
    if (!name || (ct !== 'ENT' && ct !== 'SME')) continue
    const months = {}; MON.forEach((m, idx) => { months[m] = num(r[mc + idx]) })
    const priority = pc >= 0 ? /priority|yes|high/i.test(norm(r[pc])) : false
    const potDrr   = pdc >= 0 ? num(r[pdc]) : 0
    accts.push({ name, key: key(r[0]), seg: ct, seller: norm(r[2]), sales: norm(r[3]), sam: norm(r[4]), kam: norm(r[5]), priority, potDrr, months })
  }

  // Parse daily sheet into { out: {accountKey: {dateLabel: count}}, dates: [] }
  function dailyFrom(rows) {
    const out = {}, dates = []
    if (!rows || rows.length < 2) return { out, dates }
    let hr = -1, best = 0
    for (let ri = 0; ri < Math.min(rows.length, 6); ri++) {
      let cnt = 0; (rows[ri] || []).forEach(h => { if (/^\d{1,2}-[A-Za-z]{3}/.test((h || '').toString().trim())) cnt++ })
      if (cnt > best) { best = cnt; hr = ri }
    }
    if (hr < 0) return { out, dates }
    const hdr = rows[hr], dcols = []; let nameCol = -1
    hdr.forEach((h, ci) => {
      const t = (h || '').toString().trim()
      if (/^\d{1,2}-[A-Za-z]{3}/.test(t)) { dcols.push({ ci, label: t }); dates.push(t) }
      else if (nameCol < 0 && /merchant|brand|account|name/i.test(t)) nameCol = ci
    })
    if (nameCol < 0) nameCol = 0
    for (let i = hr + 1; i < rows.length; i++) {
      const r = rows[i]; const nm = norm(r[nameCol])
      if (!nm || nm.toLowerCase() === 'totals') continue
      const k = key(r[nameCol])
      if (!out[k]) out[k] = {}
      dcols.forEach(d => { out[k][d.label] = (out[k][d.label] || 0) + num(r[d.ci]) })
    }
    return { out, dates }
  }

  const J = dailyFrom(tabs.raw2), M = dailyFrom(tabs.raw1), A = dailyFrom(tabs.raw0)
  const elapsed = J.dates.length || 1
  const dget = (src, k, l) => (src.out[k] && src.out[k][l]) || 0
  const sumD = (src, k, days) => days.reduce((s, l) => s + dget(src, k, l), 0)
  const SP = { jun: J.dates.slice(0, elapsed), may: M.dates.slice(0, elapsed), apr: A.dates.slice(0, elapsed) }
  const merged = [...A.dates.map(l => ({ src: A, l })), ...M.dates.map(l => ({ src: M, l })), ...J.dates.map(l => ({ src: J, l }))]
  const last7 = merged.slice(-7), prev7 = merged.slice(-14, -7)
  const sumM = (k, arr) => arr.reduce((s, x) => s + dget(x.src, k, x.l), 0)

  // Compute per-account derived fields
  accts.forEach(a => {
    a.aprF    = a.months[k0] || 0
    a.mayF    = a.months[k1] || 0
    a.junMTD  = a.months[k2] || 0
    a.peak    = Math.max(0, ...MON.map(m => a.months[m] || 0))
    a.drrApr  = a.aprF / D0
    a.drrMay  = a.mayF / D1
    a.drrJun  = a.junMTD / elapsed
    a.proj    = R(a.drrJun * DIM)
    a.junSP   = sumD(J, a.key, SP.jun)
    a.maySP   = sumD(M, a.key, SP.may)
    a.aprSP   = sumD(A, a.key, SP.apr)
    a.last7   = sumM(a.key, last7)
    a.prev7   = sumM(a.key, prev7)
    a.wow     = a.prev7 > 0 ? (a.last7 - a.prev7) / a.prev7 * 100 : (a.last7 > 0 ? 100 : 0)
    a.gMJ     = a.drrMay > 0 ? (a.drrJun - a.drrMay) / a.drrMay * 100 : (a.drrJun > 0 ? 100 : 0)
    a.gAJ     = a.drrApr > 0 ? (a.drrJun - a.drrApr) / a.drrApr * 100 : (a.drrJun > 0 ? 100 : 0)
    a.spMJ    = a.maySP > 0 ? (a.junSP - a.maySP) / a.maySP * 100 : (a.junSP > 0 ? 100 : 0)
    a.active  = a.junMTD > 0
    a.degrowing = (a.drrJun < a.drrMay) && a.mayF > 0
  })

  const fmt = a => ({
    name: a.name, seg: a.seg, kam: a.kam, sam: a.sam, sales: a.sales, priority: a.priority,
    apr: R(a.aprF), may: R(a.mayF), jun: R(a.junMTD), proj: a.proj,
    peak: R(a.peak), peakDrr: R(a.peak / 30),
    potDrr: R(a.potDrr || 0), potMonthly: R((a.potDrr || 0) * 30),
    potPct: a.potDrr > 0 ? R(a.drrJun / a.potDrr * 100) : 0,
    drrApr: R(a.drrApr), drrMay: R(a.drrMay), drrJun: R(a.drrJun),
    gMJ: R(a.gMJ), gAJ: R(a.gAJ), spMJ: R(a.spMJ), wow: R(a.wow),
    last7: R(a.last7), prev7: R(a.prev7),
  })

  // Aggregate a list of accounts
  function agg(list) {
    const t = { accts: list.length, ent: 0, sme: 0, apr: 0, may: 0, jun: 0, proj: 0, degrowth: 0, active: 0, last7: 0, prev7: 0, junSP: 0, maySP: 0, aprSP: 0 }
    list.forEach(a => {
      a.seg === 'ENT' ? t.ent++ : t.sme++
      t.apr += a.aprF; t.may += a.mayF; t.jun += a.junMTD; t.proj += a.proj
      if (a.degrowing) t.degrowth++; if (a.active) t.active++
      t.last7 += a.last7; t.prev7 += a.prev7
      t.junSP += a.junSP; t.maySP += a.maySP; t.aprSP += a.aprSP
    })
    t.inactive = t.accts - t.active
    t.drrApr = R(t.apr / D0); t.drrMay = R(t.may / D1); t.drrJun = R(t.jun / elapsed)
    t.gMJ = t.may > 0 ? R(((t.jun / elapsed - t.may / D1) / (t.may / D1)) * 100) : 0
    t.gAJ = t.apr > 0 ? R(((t.jun / elapsed - t.apr / D0) / (t.apr / D0)) * 100) : 0
    t.spMJ = t.maySP > 0 ? R((t.junSP - t.maySP) / t.maySP * 100) : 0
    t.spAJ = t.aprSP > 0 ? R((t.junSP - t.aprSP) / t.aprSP * 100) : 0
    t.wow  = t.prev7 > 0 ? R((t.last7 - t.prev7) / t.prev7 * 100) : 0
    t.series = MON.map(m => R(list.reduce((s, a) => s + (a.months[m] || 0), 0)));
    ['apr', 'may', 'jun', 'proj'].forEach(f => { t[f] = R(t[f]) })
    return t
  }

  const groupBy = f => {
    const g = {}
    accts.forEach(a => { const k = key(a[f]) || '(blank)'; (g[k] = g[k] || { name: a[f] || '(blank)', list: [] }).list.push(a) })
    return g
  }

  // KAM leaderboard
  const kams = Object.values(groupBy('kam')).map(o => {
    const sg = {}
    o.list.forEach(a => { const sk = key(a.sam) || '(blank)'; (sg[sk] = sg[sk] || { name: a.sam || '(blank)', list: [] }).list.push(a) })
    const sams   = Object.values(sg).map(s => ({ name: s.name, ...agg(s.list) })).sort((x, y) => y.may - x.may)
    const growth = o.list.filter(a => (a.proj - a.mayF) > 0).sort((x, y) => (y.proj - y.mayF) - (x.proj - x.mayF)).slice(0, 8).map(fmt)
    const degr   = o.list.filter(a => a.degrowing).sort((x, y) => (x.proj - x.mayF) - (y.proj - y.mayF)).slice(0, 8).map(fmt)
    return { name: o.name, ...agg(o.list), entAgg: agg(o.list.filter(a => a.seg === 'ENT')), smeAgg: agg(o.list.filter(a => a.seg === 'SME')), sams, growth, degr }
  }).sort((x, y) => y.may - x.may)

  const sams = Object.values(groupBy('sam')).map(o => ({ name: o.name, kam: (o.list[0] || {}).kam || '', ...agg(o.list) })).sort((x, y) => y.may - x.may)

  // Sales leaders
  const salesAggList = list => {
    const g = {}
    list.forEach(a => { const k = key(a.sales) || '(blank)'; (g[k] = g[k] || { name: a.sales || '(blank)', list: [] }).list.push(a) })
    return Object.values(g).map(o => ({
      name: o.name, ...agg(o.list),
      growth: o.list.filter(a => (a.proj - a.mayF) > 0).sort((x, y) => (y.proj - y.mayF) - (x.proj - x.mayF)).slice(0, 10).map(fmt),
      degr:   o.list.filter(a => a.degrowing).sort((x, y) => (x.proj - x.mayF) - (y.proj - y.mayF)).slice(0, 10).map(fmt),
    })).sort((x, y) => y.may - x.may)
  }
  const sales = { all: salesAggList(accts), ent: salesAggList(accts.filter(a => a.seg === 'ENT')), sme: salesAggList(accts.filter(a => a.seg === 'SME')) }

  // Red flags
  const no3Days = J.dates.slice(-3)
  const no3  = accts.filter(a => sumD(J, a.key, no3Days) === 0 && a.mayF > 0).sort((x, y) => y.mayF - x.mayF).map(fmt)
  const no7  = accts.filter(a => a.last7 === 0 && a.mayF > 0).sort((x, y) => y.mayF - x.mayF).map(fmt)
  const zero = accts.filter(a => a.junMTD === 0 && (a.mayF > 0 || a.aprF > 0)).sort((x, y) => y.mayF - x.mayF).map(fmt)

  // Movers
  const gain    = accts.filter(a => (a.proj - a.mayF) > 0).sort((x, y) => (y.proj - y.mayF) - (x.proj - x.mayF)).map(fmt)
  const degr    = accts.filter(a => a.degrowing).sort((x, y) => (x.proj - x.mayF) - (y.proj - y.mayF)).map(fmt)
  const degrEnt = degr.filter(a => a.seg === 'ENT')
  const degrSme = degr.filter(a => a.seg === 'SME')

  const totalAgg = agg(accts)
  const overall  = {
    total: totalAgg, ent: agg(accts.filter(a => a.seg === 'ENT')), sme: agg(accts.filter(a => a.seg === 'SME')),
    elapsed, DIM, last3: no3Days, last7: last7.map(x => x.l), prev7: prev7.map(x => x.l), spDays: SP.jun,
  }

  const potential = accts.filter(a => a.priority).sort((x, y) => y.mayF - x.mayF).map(fmt)

  return {
    generated: new Date().toISOString().slice(0, 10),
    win: {
      L: [(wm[0] && wm[0].full) || MLABe[c0 - mc] || 'Prev', (wm[1] && wm[1].full) || MLABe[c1 - mc] || 'Prev', (wm[2] && wm[2].full) || MLABe[c2 - mc] || 'Current'],
      S: [(wm[0] && wm[0].short) || MSHORT[0], (wm[1] && wm[1].short) || MSHORT[0], (wm[2] && wm[2].short) || MSHORT[0]],
      dim: DIM,
    },
    mlab: MLABe, overall, kams, sams, sales, potential,
    overview: {
      no3, no7, zero, gain, drop: degr, degr, degrEnt, degrSme,
      all: accts.map(fmt),
      last7Daily: J.dates.slice(-7).map(l => ({ label: l, total: R(accts.reduce((s, a) => s + dget(J, a.key, l), 0)) })),
      cnt: { no3: no3.length, no7: no7.length, zero: zero.length, degrEnt: degrEnt.length, degrSme: degrSme.length },
    },
  }
}

// ─── SAMPLE DATA GENERATOR ────────────────────────────────────────────────────
// Builds a synthetic tabs payload identical in shape to a real Google Sheet export.
export function generateSampleData() {
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0
      let t = Math.imul(a ^ (a >>> 15), 1 | a)
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
  }
  const rnd = mulberry32(20260721)
  const pick    = arr => arr[Math.floor(rnd() * arr.length)]
  const randInt = (a, b) => a + Math.floor(rnd() * (b - a + 1))

  const KAMS = [
    { name: 'Aditya Verma',         sams: ['Ishaan Kapoor', 'Meher Sethi'] },
    { name: 'Neha Kapoor',          sams: ['Farhan Ali', 'Divya Bhatt'] },
    { name: 'Rajesh Menon',         sams: ['Sneha Ramanathan', 'Vikram Iyer'] },
    { name: 'Sanya Malhotra',       sams: ['Aman Gill', 'Priyanka Das'] },
    { name: 'Karthik Subramaniam',  sams: ['Ritika Chawla', 'Yusuf Shaikh'] },
    { name: 'Ananya Bose',          sams: ['Devika Nair', 'Rohan Kulkarni'] },
  ]
  const SALES_LEADERS = ['Arjun Desai', 'Meera Pillai', 'Vikram Chawla', 'Ritu Sharma', 'Sameer Khan', 'Tanvi Oberoi']

  const PREFIX = ['Urban','Zesty','Nova','Bright','Coastal','Metro','Pure','Swift','Golden','Silver','Crimson','Vivid','Prime','Elevate','Sunrise','Everest','Terra','Aster','Lumen','Orbit','Cedar','Maple','Indigo','Vertex','Peak','Horizon','Bloom','Nimbus','Quartz','Sable','Amber','Ivory','Onyx','Pearl','Copper','Meridian','Lush','Rustic','Solace','Kindred','Wildcraft','Northfield','Southwind','Windermere','Alpine']
  const SUFFIX = ['Foods','Apparel','Electronics','Home','Beauty','Sports','Kids','Pharma','Mobility','Wellness','Snacks','Kitchen','Outdoors','Bags','Footwear','Decor','Toys','Fitness','Skincare','Gadgets','Pet Co','Stationery','Furniture','Jewellery','Grocery','Bakes','Nutrition','Eyewear','Watches','Naturals']
  const usedNames = new Set()
  function brandName() { let n; do { n = pick(PREFIX) + ' ' + pick(SUFFIX) } while (usedNames.has(n)); usedNames.add(n); return n }
  function pickTrend() { const r = rnd() * 100; if (r < 36) return 'grow'; if (r < 60) return 'decline'; if (r < 78) return 'flat'; if (r < 88) return 'volatile'; return 'churned' }

  function distributeDaily(total, days, tailZero) {
    tailZero = tailZero || 0
    const activeDays = Math.max(0, days - tailZero)
    const vals = new Array(days).fill(0)
    if (total <= 0 || activeDays <= 0) return vals
    const weights = []; for (let d = 0; d < activeDays; d++) weights.push(0.55 + rnd())
    const sumW = weights.reduce((a, b) => a + b, 0)
    for (let d = 0; d < activeDays; d++) vals[d] = R(total * weights[d] / sumW)
    let diff = total - vals.reduce((a, b) => a + b, 0), i = 0, guard = 0
    while (diff !== 0 && guard < activeDays * 80) { const d = i % activeDays; if (diff > 0) { vals[d]++; diff-- } else if (vals[d] > 0) { vals[d]--; diff++ } i++; guard++ }
    return vals
  }

  // 14 months: Jun'25(0) … May'26(11) Jun'26(12) Jul'26 MTD(13)
  function genMonthly(baseVol, trend) {
    const vals = []
    if (trend === 'brand_new') {
      for (let i = 0; i < 13; i++) vals.push(0)
      vals.push(R(baseVol * (0.8 + rnd() * 0.6) * (20 / 31)))
      return vals
    }
    let v = baseVol * (0.6 + rnd() * 0.5)
    for (let i = 0; i < 13; i++) {
      let g
      if (trend === 'grow')     g = 0.02 + rnd() * 0.07
      else if (trend === 'decline')  g = -(0.02 + rnd() * 0.08)
      else if (trend === 'volatile') g = -0.18 + rnd() * 0.36
      else if (trend === 'churned')  g = -0.01 + rnd() * 0.03
      else g = -0.015 + rnd() * 0.03
      v = Math.max(0, v * (1 + g)); vals.push(R(v))
    }
    let julFull
    if (trend === 'churned')  julFull = 0
    else if (trend === 'decline') julFull = Math.max(0, vals[12] * (1 - (0.04 + rnd() * 0.08)))
    else if (trend === 'grow')    julFull = vals[12] * (1 + 0.02 + rnd() * 0.06)
    else julFull = vals[12] * (1 + (-0.015 + rnd() * 0.03))
    vals.push(R(julFull * (20 / 31) * (0.88 + rnd() * 0.22)))
    return vals
  }

  const accounts = []
  const FLAGSHIPS = [
    { name: 'Everest Nutrition',       seg: 'ENT', baseVol: 9200, trend: 'grow' },
    { name: 'Northfield Apparel',      seg: 'ENT', baseVol: 8600, trend: 'decline' },
    { name: 'Coastal Home Essentials', seg: 'ENT', baseVol: 7800, trend: 'flat' },
    { name: 'Vertex Electronics',      seg: 'ENT', baseVol: 8900, trend: 'grow' },
  ]
  FLAGSHIPS.forEach(f => {
    usedNames.add(f.name)
    const kam = pick(KAMS), sam = pick(kam.sams), sales = pick(SALES_LEADERS)
    accounts.push({ name: f.name, seg: f.seg, kam: kam.name, sam, sales, monthly: genMonthly(f.baseVol, f.trend), quietTail: 0 })
  })
  for (let i = 0; i < 90; i++) {
    const seg    = rnd() < 0.32 ? 'ENT' : 'SME'
    const base   = seg === 'ENT' ? randInt(1500, 7000) : randInt(80, 1200)
    const trend  = pickTrend()
    const kam    = pick(KAMS), sam = pick(kam.sams), sales = pick(SALES_LEADERS)
    const quietTail = (trend !== 'brand_new' && rnd() < 0.14) ? pick([3, 4, 7, 9, 12]) : 0
    accounts.push({ name: brandName(), seg, kam: kam.name, sam, sales, monthly: genMonthly(base, trend), quietTail })
  }
  for (let i = 0; i < 3; i++) {
    const seg = rnd() < 0.32 ? 'ENT' : 'SME'; const base = seg === 'ENT' ? randInt(1500, 4000) : randInt(150, 900)
    const kam = pick(KAMS), sam = pick(kam.sams), sales = pick(SALES_LEADERS)
    accounts.push({ name: brandName(), seg, kam: kam.name, sam, sales, monthly: genMonthly(base, 'brand_new'), quietTail: 0 })
  }

  // Priority accounts
  const priorityIdx = new Set()
  while (priorityIdx.size < 12) priorityIdx.add(randInt(0, accounts.length - 1))
  accounts.forEach((a, i) => {
    if (priorityIdx.has(i)) {
      a.priority = true
      const curDrr = a.monthly[12] / 30
      const factor = rnd() < 0.5 ? (0.7 + rnd() * 0.25) : (1.1 + rnd() * 0.5)
      a.potDrr = Math.max(1, R(curDrr / factor))
    } else { a.priority = false; a.potDrr = 0 }
  })

  // Build master sheet (2D array)
  const MC = 8
  const monthLabels = ["Jun'25","Jul'25","Aug'25","Sep'25","Oct'25","Nov'25","Dec'25","Jan'26","Feb'26","Mar'26","Apr'26","May'26","Jun'26","Jul'26 MTD"]
  const row0 = new Array(MC).fill(''); row0[0] = 'Shipment Growth Tracker — Master (Sample)'; monthLabels.forEach(m => row0.push(m))
  const row1 = new Array(MC).fill(''); for (let i = 0; i < 7; i++) row1.push('2025'); for (let i = 0; i < 7; i++) row1.push('2026')
  const row2 = ['Account Name', 'Segment', 'Channel', 'Sales Leader', 'SAM', 'KAM', 'Potential DRR', 'Priority Accounts']; monthLabels.forEach(m => row2.push(m))
  const master = [row0, row1, row2]
  accounts.forEach(a => {
    const row = new Array(MC).fill('')
    row[0] = a.name; row[1] = a.seg; row[2] = 'D2C'; row[3] = a.sales; row[4] = a.sam; row[5] = a.kam
    row[6] = a.priority ? a.potDrr : ''; row[7] = a.priority ? 'Yes' : 'No'
    a.monthly.forEach(v => row.push(v))
    master.push(row)
  })

  function buildRaw(monLabel, daysInMonth, valueIndex, applyTail) {
    const header = ['Account Name']; for (let d = 1; d <= daysInMonth; d++) header.push(d + '-' + monLabel)
    const grid = [header]
    accounts.forEach(a => {
      const tail = applyTail ? (a.quietTail || 0) : 0
      grid.push([a.name].concat(distributeDaily(a.monthly[valueIndex], daysInMonth, tail)))
    })
    return grid
  }

  const tabs = {
    master,
    raw0: buildRaw('May', 31, 11, false),
    raw1: buildRaw('Jun', 30, 12, false),
    raw2: buildRaw('Jul', 20, 13, true),
    win: { months: [
      { y: 2026, m: 5, full: 'May',  short: 'May', days: 31 },
      { y: 2026, m: 6, full: 'June', short: 'Jun', days: 30 },
      { y: 2026, m: 7, full: 'July', short: 'Jul', days: 31 },
    ]},
  }

  const vm = ENGINE(tabs)
  vm.generated = '2026-07-21'
  vm.preview   = true
  return vm
}

// ─── LIVE API ─────────────────────────────────────────────────────────────────
// GET /api/sales/dashboard/summary returns a VM in this exact shape (backend:
// SalesDashboardService.getSummary — see KAM_SAM_DASHBOARD_FE_INTEGRATION.md).
// Server-side cache is ~30 min and is evicted on every team/mapping write, so a
// short client cache here just avoids redundant re-fetches on tab/filter churn
// within one visit — it is not the source of freshness.
let _cachedVM = null
let _cacheStamp = null
let _cacheShipmentType = null
const CLIENT_CACHE_MS = 25 * 60 * 1000
// Separate from _cachedVM on purpose — fetchVM (live) and getVM (sample preview)
// must never share a cache slot, or calling one after the other in the same
// session would silently hand back the wrong kind of data.
let _cachedSampleVM = null

export async function fetchVM(shipmentType = 'B2C') {
  const now = Date.now()
  if (
    _cachedVM &&
    _cacheStamp &&
    _cacheShipmentType === shipmentType &&
    now - _cacheStamp < CLIENT_CACHE_MS
  ) {
    return _cachedVM
  }
  try {
    const res = await axios.get(
      `${apiConstants.BASE_LOCAL}${apiConstants.SALES_DASHBOARD_SUMMARY}`,
      { params: { shipmentType } }
    )
    _cachedVM = res.data
    _cacheStamp = now
    _cacheShipmentType = shipmentType
    return _cachedVM
  } catch (err) {
    const status = err?.response?.status
    // 401 is already handled globally (axios response interceptor in
    // PrivateRoute.js — token refresh / logout). 403/503 are this module's own
    // access-denied / feature-unavailable states; index.js's ErrorState
    // branches on these two exact messages.
    if (status === 403) throw new Error('ACCESS_DENIED')
    if (status === 503) throw new Error('FEATURE_UNAVAILABLE')
    throw new Error(err?.response?.data?.message || err.message || 'Failed to load dashboard')
  }
}

// Raw day-level totals for the WoW / DoD trend charts. 92 days covers the
// worst case of "current month to date + 2 full prior months" (31+31+30)
// AND the 12 trailing weeks (84 days). Returns {dates:[iso...],
// dailyTotals:[{date,total}...]}; scoped server-side to the caller's
// portfolio for non-admin viewers, same as the summary.
let _cachedDaily = null
let _cachedDailyStamp = null
let _cachedDailyShipmentType = null

export async function fetchTrendDaily(shipmentType = 'B2C') {
  const now = Date.now()
  if (
    _cachedDaily &&
    _cachedDailyStamp &&
    _cachedDailyShipmentType === shipmentType &&
    now - _cachedDailyStamp < CLIENT_CACHE_MS
  ) {
    return _cachedDaily
  }
  const res = await axios.get(
    `${apiConstants.BASE_LOCAL}${apiConstants.SALES_DASHBOARD_TREND_DAILY}`,
    { params: { days: 92, shipmentType } }
  )
  _cachedDaily = res.data
  _cachedDailyStamp = now
  _cachedDailyShipmentType = shipmentType
  return _cachedDaily
}

// Call after any admin write (mapping add/edit/delete/priority) to force the
// next fetchVM() past the client cache — the server cache is already evicted
// by the backend on that same write.
export function invalidateVM() {
  _cachedVM = null
  _cacheStamp = null
  _cacheShipmentType = null
  _cachedDaily = null
  _cachedDailyStamp = null
  _cachedDailyShipmentType = null
}

// Sample-data preview path — kept for local/demo use, not called by the live
// dashboard container (index.js) anymore.
export function getVM() {
  if (!_cachedSampleVM) _cachedSampleVM = generateSampleData()
  return _cachedSampleVM
}
